import { Box, BoxProps } from "@mantine/core";

export const FormMain = (params: BoxProps) => {
  const { children, ...etcParams } = params;
  return <Box {...etcParams}>{children}</Box>;
};
